import { adaptedToMenage, menageToAdapted, menagesToAdapted } from "../../adapter/menageAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_MENAGES = "LOAD_SUCCESS_MENAGES";
export const LOAD_FAIL_MENAGES = "LOAD_FAIL_MENAGES";
export const SAVE_SUCCESS_MENAGES = "SAVE_SUCCESS_MENAGES";
export const SAVE_FAIL_MENAGES = "SAVE_FAIL_MENAGES";
export const UPDATE_SUCCESS_MENAGES = "UPDATE_SUCCESS_MENAGES";
export const UPDATE_FAIL_MENAGES = "UPDATE_FAIL_MENAGES";
export const DELETE_SUCCESS_MENAGES = "DELETE_SUCCESS_MENAGES";
export const DELETE_FAIL_MENAGES = "DELETE_FAIL_MENAGES";

export function loadMenages() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`menages`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        // make async call to database
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.menage);
          dispatch({
            type: LOAD_SUCCESS_MENAGES,
            payload: menagesToAdapted(res.menage),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_MENAGES,
            error: err,
          });
        });
    });
  };
}

export function saveMenage(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`menages`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToMenage(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.menage);
          dispatch({
            type: SAVE_SUCCESS_MENAGES,
            payload: menageToAdapted(res.menage),
          });
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_MENAGES,
            error: err,
          });
        });
    });
  };
}

export function updateMenage(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`menages/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToMenage(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.menage);
          dispatch({
            type: UPDATE_SUCCESS_MENAGES,
            payload: menageToAdapted(res.menage),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_MENAGES,
            error: err,
          })
        );
    });
  };
}

export function deleteMenage(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`menages/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.menage);
          dispatch({
            type: DELETE_SUCCESS_MENAGES,
            payload: menageToAdapted(res.menage),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_MENAGES,
            error: err,
          });
        });
    });
  };
}
